
'use strict';
angular.module('manageconfigSysManagementJlglRouterModule', []).
    config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('jlgl', { 
            url: '/jlgl', 
            views: {
                '': {
                    templateUrl: './manageConfig/sysManageMent/jlgl/jlgl_tpl.html',
                    controller: 'manageconfigSysManagementJlglCtrl'
                },
            }
        });
    }]);